export default {
  API_BASE_URL: 'http://localhost:8000',
  AUTH0_DOMAIN: 'mvf-dev.eu.auth0.com',
  AUTH0_AUDIENCE: 'http://mercury-dev.mvfglobal.com',
  AUTH0_CLIENT_ID: 'hvN0UrGUrXNOfQGsG6K0ECJqGAJIDfW2',
  LOG_ROCKET_ENABLED: false,
};
